module.exports = __webpack_public_path__ + "static/media/simple_br.9960f550.svg";